import axios from "axios";
// policy-based challenge 사이트키 (index.html 로드 스크립트와 동일 키)
const reCAPTCHAPolicyBasedSiteKey = process.env.REACT_APP_RE_CAPTCHA_POLICY_BASED_CHALLENGE_SITE_KEY;

export const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_BASEURL,
});

export const axiosInstanceNoLoading = axios.create({
  baseURL: process.env.REACT_APP_API_BASEURL,
});

export const axiosInstanceNoAuth = axios.create({
  baseURL: process.env.REACT_APP_API_BASEURL,
});

export const axiosInstanceCourt = axios.create({
  baseURL: process.env.REACT_APP_COURT_BASSEURL,
});

export const axiosInstanceWithCaptcha = async (action: string) => {
  // policy-based challenge: 토큰 + 사이트키 헤더를 함께 전달
  await new Promise<void>((resolve) => grecaptcha.enterprise.ready(resolve));
  const token = await grecaptcha.enterprise.execute(reCAPTCHAPolicyBasedSiteKey, { action });
  const axiosInstance = axios.create({
    baseURL: process.env.REACT_APP_API_BASEURL,
    headers: {
      "X-Recaptcha-Token": token,
      "X-Recaptcha-Site-Key": reCAPTCHAPolicyBasedSiteKey,
    },
  });
  return axiosInstance;
};
